import cancelWaitlistImg from '../../../../assets/images/TMS/delete.png';
import cancelWaitlistWhiteImg from '../../../../assets/images/TMS/delete-white.png';
import clearWaitlistImg from '../../../../assets/images/TMS/queue.png';
import clearWaitlistWhiteImg from '../../../../assets/images/TMS/queue-white.png';
import editWaitlistImg from '../../../../assets/images/TMS/edit.png';
import editWaitlistWhiteImg from '../../../../assets/images/TMS/edit-white.png';
import seatPartyImg from '../../../../assets/images/TMS/seat-party.png';
import seatPartyWhiteImg from '../../../../assets/images/TMS/seat-party-white.png';
import actionBlackImg from '../../../../assets/images/Fireboard/action_black.png';
import actionBlackWhiteImg from '../../../../assets/images/TMS/menu-vertical-white.png';
import moveImg from '../../../../assets/images/TMS/move.png';
import moveWhiteImg from '../../../../assets/images/TMS/move-white.png';
import smsImg from '../../../../assets/images/TMS/sms.png';
import smsWhiteImg from "../../../../assets/images/Fireboard/action_buttons/sms_white.png";
import strings from '../../../../globalization';

const Actions = [
  { id: 0, label: strings.seatPartyLabel, type: 'seatParty', icon: seatPartyImg, whiteIcon: seatPartyWhiteImg },
  { id: 1, label: strings.returnWaitlistLabel, type: 'clearSeating', icon: clearWaitlistImg, whiteIcon: clearWaitlistWhiteImg },
  { id: 2, label: strings.editWaitlistLabel, type: 'updateBooking', icon: editWaitlistImg, whiteIcon: editWaitlistWhiteImg },
  { id: 3, label: strings.cancelWaitlistLabel, type: 'cancelWaitlist', icon: cancelWaitlistImg, whiteIcon: cancelWaitlistWhiteImg },
  { id: 4, label: strings.smsGuestLabel, type: 'smsGuest', icon: smsImg, whiteIcon: smsWhiteImg },
  { id: 5, label: strings.moveWaitlistLabel, type: 'moveWaitlist', icon: moveImg, whiteIcon: moveWhiteImg },
  { id: 6, label: strings.allActions, type: 'allActions', icon: actionBlackImg, whiteIcon: actionBlackWhiteImg },
];

const isActionVisible = (booking, type) => {
  switch (type) {
    case 'updateBooking':
      return booking?.status === 0 || booking?.status === 7 || booking?.status === 9; //enable for pending , completed and cancelled booking
    case 'seatParty':
      return booking?.status === 0; //enable for pending booking
    case 'clearSeating':
      return booking?.status === 7 || booking?.status === 9; //enable for complete, and cancelled booking 
    case 'cancelWaitlist':
      return booking?.status === 0; //enable for pending booking
    case 'moveWaitlist':
      return booking?.status === 0;
    default:
      return true;
  }
};

export { Actions, isActionVisible };
